import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import Spinner from "../../../../components/presentationals/Spinner";
import { getJCJPIDs } from "../../../../utils/common/index";
import { ExportToCsv } from "export-to-csv";
import { CustomCardStock } from "../../../../components/customCardStock/index";
import { stockCsvFilter } from "../../../../utils/common/csvMappings/deviceStockCsv";
import Error from "../../../../components/Error/index";
import {
  fetchShowAlert,
  hideAlert,
} from "../../../../redux/actions/homeAction";
import DeviceStock from "../../../../views/DeviceStock/index";
import { triggerDashboardAudit } from "../../../../redux/actions";
// import InfoIcon from '@material-ui/icons/Info';
// import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
export const StockTabs = (props) => {
  const dispatch = useDispatch();
  const { stockObj, csvLoading } = useSelector((state) => state.homeReducer);
  let {
    url,
    csvEndPointUrl /*, isCsvActive */,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    triggerStockAPI,
    triggerStockCsvAPI,
    isCsvActive,
    moduleName,
    viewName,
  } = props;

  let endpointData = stockObj && stockObj.stockData;
  let tableContainedData =
    endpointData && endpointData[url] && endpointData[url][0];

  let { level, jioPointId, partnerRT } = getJCJPIDs(filterValue);

  if (filterValue.partnerName === "JPM") {
    tableContainedData = {
      jioQtyCount: "0",
      ownQtyCount: "0",
      paQtyCount: "0",
      partnerBrandQtyCount: "0",
      pbQtyCount: "0",
      jioPhoneNextQtyCount: "0",
    };
  }

  const data = {
    id: filterValue.selectedRole
      ? filterValue.selectedRole.split(" - ")[2]
      : filterValue.orgId,
    partnerRoleType: partnerRT, //filterValue.selectedPartnerRoleName,
    fromDate: headerSelectedDateFrom,
    toDate: headerSelectedDateTo,
    section: props.section,
    moduleName: props.moduleName,
    level: level,
    jioPointId: jioPointId,
  };

  useEffect(() => {
    const controller = new AbortController();

    function fetchData() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: url,
        },
        params: data,
        extraData: url,
      };

      return dispatch(triggerStockAPI(obj, controller.signal));
    }
    if (stockObj && stockObj.stockData[url] === undefined) {
      fetchData();
    }

    // Cleanup function to cancel the request if the component unmounts
    return () => {
      controller.abort(); // Cancels the request when the component unmounts
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerSelectedDateFrom, headerSelectedDateTo]);
  // console.log(props)

  const sendAudit = () => {
    const obj = {
      headers: {
        url: "/add-dashboard-audit",
      },
      params: {
        action: "download",
        dashboard: moduleName,
        empId: filterValue?.orgId?.length
          ? filterValue?.orgId
          : filterValue?.agentId,
        empRole: filterValue.partnerName,
        remarks: "Dashboard Audit request",
        userType: filterValue?.site,
        viewName: viewName,
      },
    };
    triggerDashboardAudit(obj);
  };

  function fetchCsvData(tab) {
    sendAudit();

    let options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: false,
      filename: "DeviceSales_stock",
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    let csvExporter = new ExportToCsv(options);
    let brandType, spart, brandDescr, model, matModel;
    ({
      LYF: () => {
        brandType = "1";
        spart = "BA";
        brandDescr = "LYF";
        model = null;
        matModel = "MODEL";
        // setCsvLoading({
        //     ...csvLoading,
        //     LYF: true
        // })
      },
      JioFI: () => {
        brandType = "1";
        spart = "BA";
        brandDescr = "JI0";
        model = null;
        matModel = "MODEL";
        // setCsvLoading({
        //     ...csvLoading,
        //     JIOFI: true
        // })
      },
      "Jio Phone": () => {
        brandType = "1";
        spart = "BA";
        brandDescr = "";
        model = "JIOPHONE";
        matModel = "MODEL";
        // setCsvLoading({
        //     ...csvLoading,
        //     JIOPhone: true
        // })
      },
      "Partner Brand": () => {
        brandType = "2";
        spart = "BA";
        brandDescr = null;
        model = null;
        matModel = "MODEL";
      },
      Accessories: () => {
        brandType = "1";
        spart = "BC";
        brandDescr = null;
        model = null;
        matModel = "MAT";
      },
      "Jio Phone Next": () => {
        brandType = "1";
        spart = "BA";
        brandDescr = null;
        model = "Jio Phone Next";
        matModel = "MODEL";
      },
      "Jio Bharat": () => {
        brandType = "1";
        spart = "BA";
        brandDescr = null;
        model = "Jio Bharat";
        matModel = "MODEL";
      },
    })[tab]();

    function fetch() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: csvEndPointUrl,
        },
        params: {
          id: filterValue.orgId
            ? filterValue.orgId
            : filterValue.selectedRole.split(" - ")[2],
          partnerRoleType: partnerRT, //filterValue.selectedPartnerRoleName,
          fromDate: headerSelectedDateFrom,
          toDate: headerSelectedDateTo,
          section: props.section,
          moduleName: props.moduleName,
          brandType: brandType,
          spart: spart,
          brandDescr: brandDescr,
          model: model,
          matModel: matModel,

          level: level,
          jioPointId: jioPointId,
        },
        extraData: csvEndPointUrl,
        tab: tab,
      };
      // if (filterValue.partnerName === "JPM") {
      //   return;
      // }
      return dispatch(
        triggerStockCsvAPI(obj, (response, params) => {
          if (response?.content?.length) {
            let csvData = stockCsvFilter(
              props.tileName,
              partnerRT,
              tab,
              response.content
            );
            csvData && csvExporter.generateCsv(csvData);
          } else {
            dispatch(fetchShowAlert());
            setTimeout(() => {
              dispatch(hideAlert());
            }, 5000);
          }
        })
      );
    }
    fetch();
  }

  return (
    <>
      {stockObj.loading ? (
        <Spinner />
      ) : tableContainedData ? (
        <>
          <DeviceStock
            filterValue={filterValue}
            tableContainedData={tableContainedData}
            fetchCsvData={fetchCsvData}
            csvLoading={csvLoading}
            url={url}
            csvEndPointUrl={csvEndPointUrl}
            isCsvActive={isCsvActive}
          />
          <div className="disclaimer p-4 rounded">
            <ul>
              <li>{window.DISCLAIMER_1}</li>
              <li>{window.DISCLAIMER_2}</li>
            </ul>
          </div>
        </>
      ) : (
        <Error error={stockObj.error} />
      )}
    </>
  );
};

StockTabs.propTypes = {
  url: PropTypes.string,
  csvEndPointUrl: PropTypes.string,
  isCsvActive: PropTypes.string,
  filterValue: PropTypes.object,
  headerSelectedDateFrom: PropTypes.string,
  headerSelectedDateTo: PropTypes.string,
  triggerSimActivationAPI: PropTypes.func,
  triggerSimActivationCsvAPI: PropTypes.func,
};
